import { Stack } from "expo-router";
import { EvidensiaLogo } from "~/assets/logos/EvidensiaLogo";
import { Header } from "~/components/Header";

export default function AuxiliaryLayout() {
  return (
    <Stack
      initialRouteName="terms/[token]"
      screenOptions={{
        header: (props) => <Header {...props} />,
        freezeOnBlur: false,
        animation: "slide_from_right",
      }}
    >
      <Stack.Screen
        name="terms/[token]"
        options={{
          headerTitle: () => <EvidensiaLogo size={85} />,
        }}
      />
      <Stack.Screen
        name="terms/success"
        options={{
          headerTitle: () => <EvidensiaLogo size={85} />,
        }}
      />
      <Stack.Screen
        name="terms/accepted"
        options={{
          headerTitle: () => <EvidensiaLogo size={85} />,
        }}
      />
    </Stack>
  );
}
